import React from "react";
import Offer from "../../components/Offer";

const OfferPage = () => {
  return (
    <Offer />
  );
};

export default OfferPage;